import Component from "@glimmer/component";

export default class SearchFieldBase extends Component {
  get placeholder() {
    return this.args.placeholder || this.args.filter.name;
  }
}
